import { Environment, EnvironmentDisplay } from '../types/public'

// TODO split files
export class AppConfig {
  public static GATEWAY_BASE_URL = 'https://superapp-kong-api.ngrok.dev/'
  public static BRIDGE_TIMEOUT = 10 * 1000 // 10s
  public static VERSION = process.env['VERSION'] || 'unknown'
  public static COMMIT_ID = process.env['COMMIT_ID'] || 'unknown'
  public static TOKEN_EXPIRY_THRESHOLD = 5 * 60 // 5 minutes
  public static CHECK_COMPATIBILITY_SOFT_ERROR_CODES = [
    'B003-NTM006',
    'B003-NTM012',
  ]
}

export class ISSConfig {
  public static PRODUCTION = "https://kc.7app.7eleven.co.th/realms/seven-eleven-superapp"
  public static STAGING = "https://kc-stg.7app.7eleven.co.th/realms/seven-eleven-superapp"
  public static DEVELOPMENT = "https://kc-dev.7app.7eleven.co.th/realms/seven-eleven-superapp"
}

class StagingConfig extends AppConfig {
  public static GATEWAY_BASE_URL = 'https://api-gw-stg.7app.7eleven.co.th/'
}

class DevelopmentConfig extends AppConfig {
  public static GATEWAY_BASE_URL = 'https://api-gw-dev.7app.7eleven.co.th/'
}

class ProductionConfig extends AppConfig {
  public static GATEWAY_BASE_URL = 'https://api-gw.7app.7eleven.co.th/'
}

export default function getConfig(env: Environment): typeof AppConfig {
  switch (env) {
    case Environment.PRODUCTION:
      return ProductionConfig
    case Environment.STAGING:
      return StagingConfig
    case Environment.DEVELOPMENT:
      return DevelopmentConfig
    default:
      return StagingConfig
  }
}
